import { useMemo } from 'react';
import { Drawer } from '@cad-arc';
import { useDrawerControls } from '../../drawers/components/drawer-context-provider';
import { PatrolDrawerContent } from './patrol-drawer-content';

export const DirectedPatrolDrawer = function DirectedPatrolDrawer({
    unitId,
    statusId,
}: {
    unitId?: number;
    statusId?: number;
}): React.ReactElement {
    const drawerControls = useDrawerControls();
    const closeDrawer = useMemo(
        () => () => {
            drawerControls.close();
        },
        [drawerControls]
    );
    return (
        <Drawer variant="overlay" isOpen={true} size="lg" onClose={closeDrawer}>
            <PatrolDrawerContent
                header="Directed Patrol"
                attributeType="DIRECTED_PATROL"
                unitId={unitId}
                statusId={statusId}
                closeDrawer={closeDrawer}
            />
        </Drawer>
    );
};

type DirectedPatrolDrawerType = typeof DirectedPatrolDrawer;
export type { DirectedPatrolDrawerType };
